<template>
  <JoszakiCard class="flex flex-col gap-4">
    <div
      v-if="showTitle"
      class="text-2xl font-bold text-primary text-center w-full"
    >
      {{ $t("searchBox.title") }}
    </div>

    <AutocompleteProfession
      v-model="profession"
      clearable
      show-label
      :placeholder="$t('searchBox.professionPlaceholder')"
    />
    <AutocompleteCity
      v-model="city"
      clearable
      show-label
      :allowed-city-ids="allowedCityIds"
      :placeholder="$t('searchBox.cityPlaceholder')"
    />
    <JoszakiButton
      expanded
      :loading="loading"
      icon-left="search"
      @click="search"
    >
      {{ $t("searchBox.button") }}
    </JoszakiButton>
  </JoszakiCard>
</template>

<script>
import { ref, watch } from "vue";
import { useContext, useRouter } from "@nuxtjs/composition-api";
import AutocompleteProfession from "@/components/_refactored/autocomplete/AutocompleteProfession.vue";
import AutocompleteCity from "@/components/_refactored/autocomplete/AutocompleteCity.vue";
import GET_PROFESSION_CITIES from "@/components/_refactored/conductor/professions/getProfessionCities.graphql";

export default {
  components: {
    AutocompleteCity,
    AutocompleteProfession,
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const { $joszaki, $trackers, $query, localePath, i18n } = useContext();
    const router = useRouter();
    const city = ref(null);
    const profession = ref(null);
    const loading = ref(false);
    const allowedCityIds = ref(null);

    const isCityAllowed = (selectedCity) =>
      !selectedCity ||
      !allowedCityIds.value?.length ||
      allowedCityIds.value.some((id) => String(id) === String(selectedCity.id));

    const loadAllowedCities = async (selectedProfession) => {
      if (!selectedProfession) {
        allowedCityIds.value = null;
        return;
      }
      try {
        const result = await $query(GET_PROFESSION_CITIES, {
          professionId: String(selectedProfession.id),
        });
        allowedCityIds.value = (
          result.professionCityListByProfessionId || []
        ).map((item) => item.cityId);
      } catch (err) {
        allowedCityIds.value = null;
      }
      if (!isCityAllowed(city.value)) {
        city.value = null;
      }
    };

    watch(profession, loadAllowedCities);

    const search = () => {
      try {
        loading.value = true;
        if (city.value && profession.value) {
          $trackers.trackClick("SearchBoxButton");

          if (city.value.parentCity) {
            router.push(
              localePath({
                name: "professionalsParentCity",
                params: {
                  profession: profession.value.seoName,
                  parentCity: city.value.parentCity.seoName,
                  city: city.value.seoName,
                },
              })
            );
            return;
          }

          router.push(
            localePath({
              name: "professionals",
              params: {
                profession: profession.value.seoName,
                city: city.value.seoName,
              },
            })
          );
        } else if (!city.value) {
          $joszaki.toast({
            message: i18n.t("searchBox.inputCityError"),
            type: "error",
          });
        } else if (!profession.value) {
          $joszaki.toast({
            message: i18n.t("searchBox.inputProfessionError"),
            type: "error",
          });
        }
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    return {
      city,
      profession,
      loading,
      allowedCityIds,
      search,
    };
  },
};
</script>
